import { Step } from 'react-joyride';

export const sellerOffersSteps: Step[] = [
  {
    target: 'body',
    content: 'Manage all offers on your properties in one convenient place.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="offers-stats"]',
    content: 'See offer totals at a glance: pending offers need your attention, plus accepted, rejected, and withdrawn counts.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="offers-search"]',
    content: 'Search offers by property address and sort by newest, highest, or lowest offer amounts.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="offers-tabs"]',
    content: 'Filter offers by status. Pending offers require action - review and respond to each one.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="offer-card"]',
    content: 'Each offer card shows buyer details, offer amount, and closing timeline. Click to view full details and respond.',
    disableBeacon: true,
  },
];
